/**
 * Design Tokens — Level 1: Primitives (CSS var references)
 * Source of truth: styles/tokens-base.css + styles/tokens-dark.css
 * Prefer semantic tokens. Primitives for edge cases only.
 */

export const colors = {
  white: "#ffffff", black: "#000000", iOSBlue: "#007aff",
  gray: {
    1000: "var(--cg-gray-1000)", 950: "var(--cg-gray-950)",
    900: "var(--cg-gray-900)", 850: "var(--cg-gray-850)",
    800: "var(--cg-gray-800)", 700: "var(--cg-gray-700)",
    600: "var(--cg-gray-600)", 500: "var(--cg-gray-500)",
    400: "var(--cg-gray-400)", 300: "var(--cg-gray-300)",
    200: "var(--cg-gray-200)", 100: "var(--cg-gray-100)",
    50: "var(--cg-gray-50)",
  },
  blue: { 400: "var(--cg-blue-400)", 500: "var(--cg-blue-500)", 600: "var(--cg-blue-600)" },
  purple: { 300: "var(--cg-purple-300)", 400: "var(--cg-purple-400)" },
  green: { 400: "var(--cg-green-400)" },
  teal: { 400: "var(--cg-teal-400)" },
  yellow: { 400: "var(--cg-yellow-400)" },
  orange: { 400: "var(--cg-orange-400)" },
  red: { 400: "var(--cg-red-400)", 500: "var(--cg-red-500)" },
  pink: { 300: "var(--cg-pink-300)", 400: "var(--cg-pink-400)", 500: "var(--cg-pink-500)" },
} as const;

export const spacing = {
  0: "0px", 1: "var(--cg-space-1)", 2: "var(--cg-space-2)",
  3: "var(--cg-space-3)", 4: "var(--cg-space-4)", 5: "var(--cg-space-5)",
  6: "var(--cg-space-6)", 8: "var(--cg-space-8)", 10: "var(--cg-space-10)",
  12: "var(--cg-space-12)",
} as const;

export const radius = {
  none: "0px", xs: "var(--cg-radius-xs)", sm: "var(--cg-radius-sm)",
  md: "var(--cg-radius-md)", lg: "var(--cg-radius-lg)", xl: "var(--cg-radius-xl)",
  "2xl": "var(--cg-radius-2xl)", full: "var(--cg-radius-full)",
} as const;

export const fontSize = {
  xs: "var(--cg-font-xs)", sm: "var(--cg-font-sm)", base: "var(--cg-font-base)",
  md: "var(--cg-font-md)", lg: "var(--cg-font-lg)", xl: "var(--cg-font-xl)",
  "2xl": "var(--cg-font-2xl)",
} as const;

export const fontWeight = {
  normal: "var(--cg-weight-normal)", medium: "var(--cg-weight-medium)",
  semibold: "var(--cg-weight-semibold)", bold: "var(--cg-weight-bold)",
} as const;

export const lineHeight = { tight: "1.25", normal: "1.5", relaxed: "1.6" } as const;

export const duration = {
  fast: "var(--cg-duration-fast)", normal: "var(--cg-duration-normal)",
  standard: "var(--cg-duration-standard)", slow: "var(--cg-duration-slow)",
} as const;

export const easing = {
  default: "var(--cg-ease-default)", ios: "var(--cg-ease-ios)",
  spring: "var(--cg-ease-spring)",
} as const;
